import * as React from "react";
import MuiInput, {
    InputProps as MuiInputProps,
    InputClassKey as MuiInputClassKey
} from "@material-ui/core/Input";

export type InputClassKey = MuiInputClassKey;

export interface InputProps extends MuiInputProps { }

class Input extends React.PureComponent<InputProps> {
    render() {
        const { ...props } = this.props;
        return <MuiInput {...props}>
            {this.props.children}
        </MuiInput>;
    }
}

export default Input; 